import { render, staticRenderFns } from "./BAutocompleteFormTemplate.vue?vue&type=template&id=0d6b8680&"
import script from "./BAutocompleteFormTemplate.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteFormTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports